import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getProductImageUrl } from "../../utils/image";

const LoanProductCard = ({ loan }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("secondPart");

  const goToLoanDetail = () => {
    navigate(`/select-loan/${loan.id}`);
  };

  return (
    <div
      onClick={goToLoanDetail}
      style={{
        cursor: "pointer",
        borderRadius: "12px",
        background: "linear-gradient(135deg, #FF8533 0%, #FF6500 100%)",
        padding: "2px",
        boxSizing: "border-box",
        width: "100%",
        maxWidth: "280px",
        margin: "0 auto",
      }}
    >
      {/* White “inner” card */}
      <div
        style={{
          borderRadius: "10px",
          backgroundColor: "#fff",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        {/* 1) Loan Image (centered) */}
        <div
          style={{
            width: "100%",
            height: "140px",
            overflow: "hidden",
            borderRadius: "8px",
            marginBottom: "12px",
          }}
        >
          <img
            src={loan.image_url || "/assets/img/ci/img/img-pico-loan.png"}
            alt={loan.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* 2) Loan Name */}
        <h3
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#333",
            textAlign: "center",
            margin: "0 0 8px 0",
          }}
        >
          {loan.name}
        </h3>

        {/* 3) Advantage text in a green banner */}
        {/* <div
          style={{
            backgroundColor: "#E8FFF7",
            borderRadius: "6px",
            padding: "6px 12px",
            marginBottom: "16px",
            width: "100%",
            textAlign: "center",
            boxSizing: "border-box",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#027A52",
              margin: 0,
              lineHeight: 1.4,
            }}
          >
            {getLoanAdvantagesText(loan)}
          </p>
        </div> */}

        {/* 4) “รายละเอียด” link */}
        <p
          style={{
            fontSize: "14px",
            fontWeight: 500,
            color: "var(--color-primary, #FF6500)",
            margin: 0,
          }}
        >
          {t("detail")}
        </p>
      </div>
    </div>
  );
};

export default LoanProductCard;
